<style scoped>
.v-application .subtitle-1 {
  font-family: "Prompt", sans-serif !important;
}
.v-application .text-h5 {
  font-family: "Prompt", sans-serif !important;
}
.v-application .white {
  border: #ccd0d9 solid 1px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.v-data-table__wrapper > table > thead > tr {
  background-color: #039be5;
}
.v-data-table__wrapper > table > thead > tr > th {
  font-size: 14px;
  color: white !important;
}
.v-input__slot {
  min-height: unset !important;
}
.v-text-field--box .v-input__slot,
.v-text-field--outline .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}
.handle {
  cursor: move;
}
</style>

<template>
  <div>
    <v-layout class="d-flex justify-space-between mb-5">
      <div
        class="text-h5 font-weight-black info--text text-spacing"
        color="blue"
      >
        สัญญา {{ header }}
      </div>
      <v-spacer></v-spacer>
      <v-btn color="white" elevation="0" large @click="back()" class="mr-4"
        >ยกเลิก</v-btn
      >
      <v-dialog v-model="dialog" max-width="640">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="success"
            elevation="0"
            large
            dark
            v-bind="attrs"
            v-on="on"
            v-if="!isEdit"
          >
            <v-icon left>mdi-file-plus</v-icon>บันทึกเอกสาร
          </v-btn>
        </template>
        <v-card>
          <v-card-title
            class="text-h5 font-weight-black info--text text-spacing"
            color="blue"
          >
            บันทึกเอกสาร {{ header }}
          </v-card-title>
          <v-card-text>
            <v-divider></v-divider>
            <v-row justify="center">
              <v-radio-group
                row
                class="mb-n5"
                v-model="sendOrsave"
                @change="genEmailDetail()"
              >
                <v-radio
                  class="pr-6"
                  label="บันทึกข้อมูลอย่างเดียว"
                  hide-details
                  value="NSEND"
                ></v-radio>
                <v-radio
                  class="pr-6"
                  label="ส่งอีเมลล์พร้อมกับบันทึก"
                  hide-details
                  value="SEND"
                ></v-radio>
              </v-radio-group>

              <v-col cols="12" lg="12" v-if="sendOrsave == 'SEND'">
                <v-row justify="center">
                  <v-col cols="12" lg="10" class="mb-n10 mt-n5">
                    <span class="email-text">จาก :</span>
                    <v-text-field
                      dense
                      outlined
                      v-model="Esender"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="10" class="mb-n10">
                    <span class="email-text">ถึง :</span>
                    <v-text-field
                      dense
                      outlined
                      v-model="Ereciever"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="10" class="mb-n10">
                    <span class="email-text">หัวข้อ :</span>
                    <v-text-field
                      dense
                      outlined
                      v-model="Eheader"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="10" class="my-n2"> </v-col>
                  <v-col cols="12" lg="10" class="mt-n2">
                    <span class="email-text">ข้อความ :</span>
                    <v-textarea
                      row-height="5"
                      dense
                      outlined
                      v-model="Emessage"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" lg="10" class="mt-n5">
                    <v-btn color="primary" width="100%" @click="sendemail()">
                      ส่งอีเมลล์พร้อมกับบันทึก
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" lg="12" v-else>
                <v-btn color="success" width="100%" @click="save()">
                  บันทึกข้อมูล
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-btn
        color="success"
        elevation="0"
        large
        dark
        @click="edit()"
        v-if="isEdit && IS_RENEW == false"
      >
        <v-icon left>mdi-file-plus</v-icon>แก้ไขสัญญา
      </v-btn>
      <v-btn
        color="success"
        elevation="0"
        large
        dark
        @click="edit()"
        v-if="isEdit && IS_RENEW == true"
      >
        <v-icon left>mdi-file-plus</v-icon>ต่อสัญญา
      </v-btn>
    </v-layout>
    <v-divider class="mt-n1 mb-3"></v-divider>
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-layout class="d-flex justify-space-between mb-15">
        <v-row>
          <!-- :items="Find_CustomerName" -->
          <v-col cols="12" lg="5" class="mb-n8">
            <v-text-field
              dense
              outlined
              label="รหัสลูกค้า / รหัสโซน"
              v-model="zone_code"
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="7" class="mb-n11">
            <v-spacer></v-spacer>
          </v-col>
          <v-col cols="12" lg="5" class="mb-n8">
            <v-combobox
              :disabled="isEdit"
              label="เลือกลูกค้า"
              dense
              outlined
              :items="hospname"
              item-text="CUSTOMER_NAME"
              item-value="NEWCUSTOMER_ID"
              return-object
              required
              :rules="[(v) => !!v || 'กรุณาเลือกลูกค้า']"
              v-model="cus_name"
              @change="(event) => select_customer(event)"
            ></v-combobox>
          </v-col>
          <v-col cols="12" lg="7" class="mb-n11">
            <v-spacer></v-spacer>
          </v-col>
          <v-col cols="12" lg="5" class="mb-n10">
            <v-text-field
              label="เลขประจำตัวผู้เสียภาษี"
              dense
              outlined
              v-model="cus_tax"
              :disabled="isEdit"
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="7" class="mb-n11">
            <v-spacer></v-spacer>
          </v-col>
          <v-col cols="12" lg="5" class="mb-n10">
            <v-text-field
              label="สำนักงาน / สาขาเลขที่"
              dense
              outlined
              v-model="cus_branch"
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="7" class="mb-n11">
            <v-spacer></v-spacer>
          </v-col>
          <v-col cols="12" lg="5" class="mb-n10">
            <v-text-field
              label="ที่อยู่"
              dense
              outlined
              v-model="cus_address"
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="7" class="mb-n7">
            <v-spacer></v-spacer>
          </v-col>
          <v-col cols="12" lg="3" class="mb-n7">
            <addressinput-subdistrict v-model="cus_subdis" />
          </v-col>
          <!-- <v-col cols="12" lg="8" class="mb-n7">
            <v-spacer></v-spacer>
          </v-col>-->
          <v-col cols="12" lg="3" class="mb-n7">
            <addressinput-district v-model="cus_dis" />
          </v-col>
          <v-col cols="12" lg="6" class="mb-n7">
            <v-spacer></v-spacer>
          </v-col>

          <v-col cols="12" lg="3" class="mb-n7">
            <addressinput-province v-model="cus_pro" />
          </v-col>
          <v-col cols="12" lg="3" class="mb-n7">
            <addressinput-zipcode v-model="cus_zip" />
          </v-col>
          <v-col cols="12" lg="6">
            <v-spacer></v-spacer>
          </v-col>

          <!-- <v-col cols="12" lg="6" class="mb-n10">
            <v-text-field label="รหัสไปรษณีย์" dense single-line outlined></v-text-field>
          </v-col>-->
          <!-- <v-col cols="12" lg="6" class="mb-n11">
            <v-spacer></v-spacer>
          </v-col>-->
        </v-row>
        <v-spacer></v-spacer>

        <v-row style="justify-content: flex-end">
          <v-col cols="12" lg="12" class="mb-2">
            <v-layout class="d-flex flex-row-reverse mb-n15">
              <div class="d-flex flex-column align-center" style="width: 80px">
                <v-btn icon height="30" xLarge>
                  <v-icon>mdi-dots-horizontal</v-icon>
                </v-btn>
                <p class="mb-0" style="font-size: 12px">เพิ่มเติม</p>
              </div>
              <div class="d-flex flex-column align-center" style="width: 80px">
                <v-btn icon height="30" xLarge @click="downloadPdf()">
                  <v-icon>mdi-download</v-icon>
                </v-btn>
                <p class="mb-0" style="font-size: 12px">ดาวน์โหลด</p>
              </div>
              <div class="d-flex flex-column align-center" style="width: 80px">
                <v-btn icon height="30" xLarge @click="printPdf()">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
                <p class="mb-0" style="font-size: 12px">พิมพ์เอกสาร</p>
                <!-- <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon height="30" xLarge v-on="on" v-bind="attrs">
                      <v-icon>mdi-printer</v-icon>
                    </v-btn>
                    <p class="mb-0" style="font-size: 12px">พิมพ์เอกสาร</p>
                  </template>
                   <v-list>
                    <v-list-item
                      v-for="(item, index) in listPrint"
                      :key="index"
                      @click="print_contract(item)"
                    >
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item>
                  </v-list> 
               
                </v-menu> -->
              </div>
            </v-layout>
          </v-col>

          <v-col cols="12" lg="6" class="my-7">
            <div class="subtitle-1 font-weight-bold">จำนวนรวมทั้งสิ้น</div>
            <div class="text-h5 info--text font-weight-bold">
              {{ totalVat7 | delimeter }}
            </div>
          </v-col>
          <v-col cols="12" lg="8" class="my-n1 text-right">
            <div class="subtitle-1 font-weight-bold">วันที่เริ่ม</div>
          </v-col>
          <v-col cols="12" lg="4" class="my-n1 text-right">
            <date-picker
              color="black"
              class="mb-1"
              style="width: 100%"
              :format="momentFormat"
              v-model="con_date_renew"
              v-if="IS_RENEW==true"
              @change="c_period()"
            ></date-picker>
            <date-picker
              color="black"
              class="mb-1"
              style="width: 100%"
              :format="momentFormat"
              v-model="con_date"
              v-else
            ></date-picker>
          </v-col>
          <v-col cols="12" lg="8" class="my-n4 text-right">
            <v-spacer></v-spacer>
          </v-col>
          <v-col cols="12" lg="8" class="my-n3 text-right">
            <div class="subtitle-1 font-weight-bold">
              ระยะเวลา
              <span> (ปี) </span>
              <!-- <span v-else> (เดือน) </span> -->
            </div>
          </v-col>
          <v-col cols="12" lg="4" class="my-n4">
            <v-autocomplete
              color="black"
              :items="contract_period"
              :rules="v_c_period"
              outlined
              dense
              v-model="con_period"
              @change="c_period()"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" lg="8" class="my-n5 text-right">
            <div class="subtitle-1 font-weight-bold">ครบกำหนด</div>
          </v-col>
          <v-col cols="12" lg="4" class="my-n6">
            <v-text-field
              outlined
              dense
              disabled
              filled
              color="black"
              :rules="[(v) => !!v || 'กรุณาเลือกวันที่เริ่มสัญญา']"
              v-model="con_expire"
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="8" class="my-n4 text-right">
            <div class="subtitle-1 font-weight-bold">ประเภท</div>
          </v-col>
          <v-col cols="12" lg="4" class="my-n5">
            <v-select
              :items="c_type"
              outlined
              disabled
              dense
              v-model="con_type"
              :rules="[(v) => !!v || 'กรุณาเลือกประเภทสัญญา']"
              color="black"
              @change="change_con_type()"
            ></v-select>
          </v-col>
        </v-row>
      </v-layout>
      <v-divider class="mt-n1 mb-3"></v-divider>
      <v-row>
        <v-col cols="12" lg="1">
          <div class="subtitle-1 font-weight-bold mt-1">ชื่อโปรเจค</div>
        </v-col>
        <v-col cols="12" lg="7">
          <v-text-field outlined dense></v-text-field>
        </v-col>
        <v-col cols="12" lg="1">
          <div class="subtitle-1 font-weight-bold mt-1">ราคาสินค้า</div>
        </v-col>
        <v-col cols="12" lg="3">
          <v-select
            label="เลือกราคา"
            :items="pricing"
            dense
            outlined
            v-model="price_op"
            @change="(event) => price_option(event)"
            :rules="[(v) => !!v || 'กรุณาเลือกราคาสินค้า']"
            :disabled="isEdit"
          ></v-select>
        </v-col>
      </v-row>
      <v-col cols="12" lg="12" class="mt-n3">
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" style="width: 3%">ลำดับ</th>
                <th class="text-left" style="width: 55%">
                  ชื่อสินค้า / รายละเอียด
                </th>
                <th class="text-left" style="width: 3%">จำนวน</th>
                <th class="text-left" style="width: 3%">หน่วย</th>
                <th class="text-left" style="width: 12%">ราคาต่อหน่วย</th>
                <th class="text-left" style="width: 12%">ราคารวม</th>
                <th class="text-center" style="width: 2%"></th>
              </tr>
            </thead>
            <draggable
              :list="product_list"
              tag="tbody"
              :move="onMove(product_list)"
            >
              <tr
                v-for="(item, index) in product_list"
                :key="index"
                class="handle"
              >
                <td>{{ index + 1 }}</td>
                <td>
                  <v-menu offset-y :disabled="isEdit">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :disabled="isEdit"
                        v-on="on"
                        clearable
                        placeholder="สินค้า"
                        flat
                        class="mt-2 mb-1"
                        dense
                        v-model="product_list[index].NAME"
                        @keyup="search = $event.target.value"
                        @click:clear="clearSearch()"
                      ></v-text-field>
                    </template>
                    <v-list style="max-height: 200px; overflow: auto">
                      <v-list-item
                        v-for="(item, i) in filteredItems"
                        :key="i"
                        @click="select_combo(index, item)"
                      >
                        <v-list-item-title>{{ item.NAME }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                    <!-- <v-card>
                      <v-divider></v-divider>
                      <div class="pa-1" @click.stop>
                        <v-btn
                          text
                          dark
                          small
                          color="primary"
                          depressed
                          :ripple="false"
                          style="width: 100%; justify-content: start"
                        >
                          <v-icon left>mdi-plus</v-icon>เพิ่มสินค้า
                        </v-btn>
                      </div>
                    </v-card> -->
                  </v-menu>
                  <v-textarea
                    placeholder="รายละเอียด"
                    dense
                    outlined
                    rows="1"
                    row-height="5"
                    auto-grow
                    class="my-n4"
                    v-model="product_list[index].DETAIL"
                  ></v-textarea>
                </td>
                <td>
                  <v-text-field
                    dense
                    :disabled="isEdit"
                    class="mt-3"
                    type="number"
                    v-model="product_list[index].AMOUT"
                    @keyup="changeUnit()"
                  ></v-text-field>
                </td>
                <td>
                  <v-text-field
                    dense
                    class="mt-3"
                    :disabled="isEdit"
                    v-model="product_list[index].UNIT"
                  ></v-text-field>
                </td>
                <td>
                  <v-text-field
                    dense
                    type="number"
                    class="mt-3"
                    :disabled="isEdit"
                    v-model="product_list[index].PRICE"
                    @keyup="changePrice()"
                  ></v-text-field>
                </td>

                <td style="font-size: 1rem">{{ sumCol(index) | delimeter }}</td>
                <td>
                  <v-btn icon @click="delete_product(item)" v-if="!isEdit">
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </draggable>
            <v-spacer></v-spacer>
          </template>
        </v-simple-table>
      </v-col>
      <v-col cols="12" lg="3">
        <v-btn
          color="info"
          elevation="0"
          large
          @click="add_product()"
          v-if="!isEdit"
        >
          <v-icon left>mdi-plus</v-icon>เพิ่มแถวรายการ
        </v-btn>
      </v-col>

      <v-layout class="d-flex justify-space-between mb-15">
        <v-row>
          <v-col cols="12" lg="12" class="mb-n2">
            <div class="subtitle-1 font-weight-bold">หมายเหตุ</div>
          </v-col>
          <v-col cols="12" lg="12" class="my-n5">
            <v-textarea label outlined rows="3" row-height="25"></v-textarea>
          </v-col>

          <!-- <v-col cols="12" lg="5" class="my-n5">
            <v-spacer></v-spacer>
          </v-col> -->
          <!-- <v-col cols="12" lg="12" class="my-n8">
            <v-checkbox label="ลายเซ็นอิเล็กทรอนิกส์และตรายาง"></v-checkbox>
          </v-col> -->
        </v-row>

        <v-spacer></v-spacer>

        <v-row style="justify-content: flex-end; width: 100%">
          <v-col cols="12" lg="12" class="my-n10 text-right">
            <div class="d-flex flex-column mb-6">
              <div class="d-flex flex-row-reverse">
                <div class="subtitle-1 font-weight-bold ml-15 my-1">
                  {{ summary | delimeter }}
                </div>
                <div class="subtitle-1 font-weight-bold info--text mr-15 my-1">
                  รวมเป็นเงิน
                </div>
              </div>
              <div
                class="d-flex flex-row-reverse"
                v-if="vat_option == 'ราคารวมภาษี'"
              >
                <div class="subtitle-1 font-weight-bold ml-15 my-1">
                  {{ totalVat7 | delimeter }}
                </div>
                <div class="subtitle-1 font-weight-bold info--text mr-15 my-1">
                  จำนวนเงินรวมทั้งสิ้น
                </div>
              </div>

              <div class="d-flex flex-row-reverse">
                <div class="subtitle-1 font-weight-bold ml-15 my-5">
                  {{ onlyVat7 | delimeter }}
                </div>
                <div class="subtitle-1 font-weight-bold info--text mr-15">
                  <v-checkbox
                    label="ภาษีมูลค่าเพิ่ม 7%"
                    v-model="vat7"
                    v-if="vat_option == 'ราคาไม่รวมภาษี'"
                    :disabled="isEdit"
                    @change="(evt) => checked_vat7(evt)"
                  ></v-checkbox>
                  <div class="mt-4" v-else-if="vat_option == 'ราคารวมภาษี'">
                    ภาษีมูลค่าเพิ่ม 7%
                  </div>
                  <!-- <v-checkbox label="ภาษีมูลค่าเพิ่ม 7%" v-model="vat7" v-else></v-checkbox> -->
                </div>
              </div>
              <div
                class="d-flex flex-row-reverse"
                v-if="vat_option == 'ราคารวมภาษี'"
              >
                <div class="subtitle-1 font-weight-bold ml-15 my-1">
                  {{ exclude_7 | delimeter }}
                </div>
                <div class="subtitle-1 font-weight-bold info--text mr-15 my-1">
                  ราคาไม่รวมภาษีมูลค่าเพิ่ม
                </div>
              </div>

              <div
                class="d-flex flex-row-reverse"
                v-if="vat_option == 'ราคาไม่รวมภาษี'"
              >
                <div class="subtitle-1 font-weight-bold ml-15">
                  {{ totalVat7 | delimeter }}
                </div>
                <div class="subtitle-1 font-weight-bold info--text mr-15">
                  จำนวนเงินรวมทั้งสิ้น
                </div>
              </div>
              <div class="d-flex flex-row-reverse">
                <div class="subtitle-1 font-weight-bold ml-15 my-5">
                  <span v-if="isVat3"> {{ onlyVat3 | delimeter }}</span>
                </div>
                <div class="subtitle-1 font-weight-bold info--text mr-15">
                  <v-row align="center">
                    <v-checkbox
                      label="หักภาษี ณ ที่จ่าย"
                      v-model="vat3"
                      @change="(evt) => checked_vat3(evt)"
                      :disabled="isEdit"
                    ></v-checkbox>
                    <v-select
                      v-if="isVat3"
                      dense
                      :items="se_vat3"
                      style="width: 80px"
                      class="mt-2 ml-2"
                      v-model="vat3_value"
                      :disabled="isEdit"
                      @change="(evt) => vat3_option(evt)"
                    ></v-select>
                  </v-row>
                </div>
              </div>
              <div class="d-flex flex-row-reverse" v-if="isVat3">
                <div class="subtitle-1 font-weight-bold ml-15">
                  {{ summaryVat3 | delimeter }}
                </div>
                <div class="subtitle-1 font-weight-bold info--text mr-15">
                  ยอดชำระ
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-layout>
    </v-form>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import moment from "moment";
import draggable from "vuedraggable";
import pdfMake from "@/assets/build/pdfmake";
import pdfFonts from "@/assets/build/vfs_fonts";
import month_contract from "../pdf/month_contract";
import receipt3 from "../pdf/receipt3";
import year_h_contract from "../pdf/year_h_contract"; //คลีนิครายปี
import printJS from "print-js";
export default {
  name: "BillForm",

  components: {
    draggable,
  },
  data: () => ({
    isEdit: false,
    header: "",
    Esender: "newchok.2019@gmail.com",
    previousRoute: "",
    enabled_tax: false,
    enabled_c_date: false,
    v_cal_tax: [(v) => !!v || ""],
    v_percent_tax: [(v) => !!v || ""],
    v_collect_date: [(v) => !!v || ""],
    v_waste_document: [(v) => !!v || ""],
    v_c_period: [(v) => !!v || "กรุณาเลือกจำนวนปี"],
    v_hopsname: [(v) => !!v || "กรุณากรอกสถานบริการ"],
    v_c_start: [(v) => !!v || "กรุณาเลือกวันที่ทำสัญญา"],
    v_c_type: [(v) => !!v || "กรุณาเลือกอัตราการจัดเก็บขยะ"],
    contract_period: ["1", "2", "3", "4"],
    sendOrsave: "NSEND",
    hospname: [],
    se_vat3: ["3%", "5%", "0.5%", "0.75%", "1%"],
    pricing: ["ราคาไม่รวมภาษี"],
    vat_option: "ราคาไม่รวมภาษี",
    isVat3: false,
    summaryVat3: 0,
    dialog: false,
    dialog2: false,
    totalVat7: 0,
    onlyVat7: 0,
    onlyVat3: 0,
    summary: 0.0,
    exclude_7: 0,
    product: [],
    valid: true,
    lazy: false,
    show_con_type: "",
    se_contract: "",
    momentFormat: {
      // Date to String
      stringify: (date) => {
        return date ? moment(date).locale("th").add(543, "Y").format("LL") : "";
      },
      // String to Date
      parse: (value) => {
        return value ? moment(value, "LL").toDate() : null;
      },
    },
    listPrint: [
      { title: "สัญญารายเดือน" },
      { title: "สัญญารายปี" },
      { title: "สัญญาโรงพยาบาล" },
    ],
    c_type: ["รายเดือน", "รายปี", "คิดตามกิโลกรัม"],
  }),
  filters: {
    delimeter(data) {
      let y = parseFloat(data).toFixed(2);
      let x = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      return x;
    },
    formatDate(data) {
      return moment(data).format("DD-MM-YYYY");
    },
    filPrice(data) {
      return isNaN(data) ? 0 : data;
    },
  },
  computed: {
    ...mapGetters({
      GET_CONTRACT: "Contract/GET_CONTRACT",
      GET_PRODUCT: "Contract/GET_PRODUCT",
      IS_EDIT: "Contract/IS_EDIT",
      IS_RENEW: "Contract/IS_RENEW",
    }),
    filteredItems() {
      let searchRegExp = new RegExp(this.search, "gi");
      return this.product.filter((item) => {
        if (!this.search) {
          return this.product;
        } else {
          return searchRegExp.test(item.NAME);
        }
      });
    },
    product_list() {
      let vat3 = this.GET_CONTRACT.ISVAT2;
      let vat7 = this.GET_CONTRACT.ISVAT;
      let p_option = this.vat_option;
      this.sumProductValue(vat7, vat3, p_option);
      let list_product = this.GET_PRODUCT;
      list_product
        .filter((x) => {
          return x.PRICE == null;
        })
        .map((item) => {
          return (item.PRICE = 0);
        });
      return list_product;
    },
    Ereciever: {
      get() {
        return this.GET_CONTRACT.PROVIDER_EMAIL;
      },
      set(value) {
        this.C_SET({
          key: "PROVIDER_EMAIL",
          value: value,
        });
      },
    },
    zone_code: {
      get() {
        return this.GET_CONTRACT.ZONE_CODE;
      },
      set(value) {
        if (value) this.C_SET({ key: "ZONE_CODE", value: value });
      },
    },
    cus_name: {
      get() {
        return this.GET_CONTRACT.CUSTOMER_NAME;
      },
      set(value) {
        if (value)
          this.C_SET({ key: "CUSTOMER_ID", value: value.NEWCUSTOMER_ID });
      },
    },
    cus_tax: {
      get() {
        return this.GET_CONTRACT.CUSTOMER_TAX_ID;
      },
      set(value) {
        this.C_SET({ key: "CUSTOMER_TAX_ID", value: value });
      },
    },
    cus_branch: {
      get() {
        return this.GET_CONTRACT.CUSTOMER_BRANCH;
      },
      set(value) {
        this.C_SET({ key: "CUSTOMER_BRANCH", value: value });
      },
    },
    cus_address: {
      get() {
        return this.GET_CONTRACT.CUSTOMER_ADDRESS;
      },
      set(value) {
        this.C_SET({ key: "CUSTOMER_ADDRESS", value: value });
      },
    },
    cus_subdis: {
      get() {
        return this.GET_CONTRACT.CUSTOMER_SUBDISTRICT;
      },
      set(value) {
        this.C_SET({ key: "CUSTOMER_SUBDISTRICT", value: value });
      },
    },
    cus_dis: {
      get() {
        return this.GET_CONTRACT.CUSTOMER_DISTRICT;
      },
      set(value) {
        this.C_SET({ key: "CUSTOMER_DISTRICT", value: value });
      },
    },
    cus_pro: {
      get() {
        return this.GET_CONTRACT.CUSTOMER_PROVINCE;
      },
      set(value) {
        this.C_SET({ key: "CUSTOMER_PROVINCE", value: value });
      },
    },
    cus_zip: {
      get() {
        return this.GET_CONTRACT.CUSTOMER_ZIPCODE;
      },
      set(value) {
        this.C_SET({ key: "CUSTOMER_ZIPCODE", value: value });
      },
    },
    con_date: {
      get() {
       
        return new Date(this.GET_CONTRACT.CONTRACT_START_DATE);
       
      },
      set(value) {
        this.C_SET({ key: "CONTRACT_START_DATE", value: value });
      },
    },
    con_date_renew: {
      get() {
        return new Date(this.GET_CONTRACT.CONTRACT_START_DATE);
      },
      set(value) {
        this.C_SET({ key: "CONTRACT_START_DATE", value: value });
      },
    },
    con_period: {
      get() {
        return this.GET_CONTRACT.CONTRACT_PERIOD;
      },
      set(value) {
        this.C_SET({ key: "CONTRACT_PERIOD", value: value });
      },
    },
    con_expire: {
      get() {
        return moment(this.GET_CONTRACT.CONTRACT_END_DATE)
          .locale("th").add(543,'Y')
          .format("LL");
      },
      set(value) {
        this.C_SET({ key: "CONTRACT_END_DATE", value: value });
      },
    },
    con_type: {
      get() {
        return this.GET_CONTRACT.CONTRACT_CATEGORY;
      },
      set(value) {
        this.C_SET({ key: "CONTRACT_CATEGORY", value: value });
      },
    },
    price_op: {
      get() {
        return this.GET_CONTRACT.PRICE_OPTION;
      },
      set(value) {
        this.C_SET({ key: "PRICE_OPTION", value: value });
      },
    },
    remark: {
      get() {
        return this.GET_CONTRACT.REMARK;
      },
      set(value) {
        this.C_SET({
          key: "REMARK",
          value: value,
        });
      },
    },
    vat7: {
      get() {
        return this.GET_CONTRACT.ISVAT;
      },
      set(value) {
        this.C_SET({
          key: "ISVAT",
          value: value,
        });
      },
    },
    vat7_value: {
      get() {
        return this.GET_CONTRACT.VAT_VALUE;
      },
      set(value) {
        this.C_SET({
          key: "VAT_VALUE",
          value: value,
        });
      },
    },
    vat3: {
      get() {
        this.isVat3 = this.GET_CONTRACT.ISVAT2 == 1 ? true : false;
        return this.GET_CONTRACT.ISVAT2;
      },
      set(value) {
        this.C_SET({
          key: "ISVAT2",
          value: value,
        });
      },
    },
    vat3_value: {
      get() {
        return this.GET_CONTRACT.VAT_VALUE2;
      },
      set(value) {
        this.C_SET({
          key: "VAT_VALUE2",
          value: value,
        });
      },
    },
  },
  watch: {
    con_type(value) {
      this.show_con_type = value;
    },
  },
  created() {
    
    this.isEdit = this.IS_EDIT;

    if (!this.isEdit) {
      this.price_op = this.pricing[0];
      this.getContractId(this.GET_CONTRACT.CUSTOMER_GROUP);
      this.list_customer();
      this.list_product();
      this.show_con_type = this.GET_CONTRACT.CONTRACT_CATEGORY;
    } else {
      this.price_op = this.GET_CONTRACT.PRICE_OPTION;
      this.header = this.GET_CONTRACT.CONTRACT_ID;
      this.list_customer();
      this.list_product();
      this.show_con_type = this.GET_CONTRACT.CONTRACT_CATEGORY;
    }
    this.c_period()
  },
  methods: {
    ...mapMutations({
      C_SET_PRODUCT: "Contract/SET_PRODUCT_LIST",
      C_SET_ALL: "Contract/SET_ALL_ELEMENT",
      C_SET: "Contract/SET_ELEMENT",
      LOADER: "Drawer/SET_LOADER",
    }),
    ...mapActions({
      addProduct: "Contract/add_product_list",
      delProduct: "Contract/remove_product_list",
      resetProduct: "Contract/reset_product_list",
    }),
    onMove(item) {
      this.C_SET_PRODUCT(item);
    },
    c_period() {
      let type = this.show_con_type;
      console.log(this.GET_CONTRACT.CONTRACT_START_DATE);
      // if (type == "รายปี") {
      this.C_SET({
        key: "CONTRACT_END_DATE",
        value: moment(this.GET_CONTRACT.CONTRACT_START_DATE)
          .add(parseInt(this.GET_CONTRACT.CONTRACT_PERIOD), "Y")
          .format("YYYY-MM-DD"),
      });

      // } else {
      //   this.C_SET({ key: "CONTRACT_END_DATE", value: moment(this.GET_CONTRACT.CONTRACT_START_DATE).add(parseInt(this.GET_CONTRACT.CONTRACT_PERIOD), "M").format("YYYY-MM-DD") })

      // }
    },
    genEmailDetail() {
      this.Eheader = "เอกสารสัญญาเก็บขนมูลฝอยติดเชื้อ " + this.header + "";
      this.Emessage = `เรียน  ${this.GET_CONTRACT.CUSTOMER_NAME}${"\n"}${"\n"}${
        this.$AppName.limited_company
      } ได้แนบเอกสาร เลขที่ ${
        this.header
      } มาให้ในอีเมลนี้${"\n"}${"\n"}กรุณาคลิกที่ไฟล์แนบ เพื่อดาวน์โหลดเอกสารของคุณ${"\n"}${"\n"}ท่านสามารถชำระค่าใช้จ่ายและดูรายงานการเก็บขนได้โดยผ่านลิงค์ดังกล่าว${"\n"}${
        this.$global_link
      }/Customer/${
        this.GET_CONTRACT.CUSTOMER_ID
      }${"\n"}${"\n"}ท่านสามารถแอดไลน์เพื่อติดตามการเก็บขนได้โดยคลิ๊กลิงค์ดังกล่าว${"\n"}https://line.me/R/oaMessage/@328royru/link_${
        this.GET_CONTRACT.CUSTOMER_ID
      }${"\n"}${"\n"}${"\n"}${"\n"}ด้วยความเคารพ ${
        this.$AppName.limited_company
      }`;
    },
    sendemail() {
      this.LOADER(true);
      let con_data = this.GET_CONTRACT;
      let product = this.GET_PRODUCT;
      let contract_data = {
        CONTRACT_ID: this.header,
        DATA: con_data,
        PACKAGE: product,
      };
      let email_obj = {
        CONTRACT_ID: this.header,
        email_sender: this.Esender,
        email_reciever: this.Ereciever,
        email_header: this.Eheader,
        email_content: this.Emessage,
        pdf_file: "",
        file_name: "",
      };
      this.$token_api
        .post("/insert-duplicate-contract", contract_data)
        .then((response) => {
          this.$token_api
            .post("/send-contract-email", email_obj)
            .then((response) => {
              this.$swal({
                title: "สำเร็จ",
                text: "สร้างสัญญาสำเร็จ",
                timer: 2000,
                icon: "success",
              }).then((res) => {
                // this.$store.dispatch("Quotation/reset");
                // this.quotationHeader()

                this.LOADER(false);
                this.dialog = false;
                this.back();
              });
            })
            .catch((err) => {
              this.$swal("กรุณาลองใหม่อีกครั้ง", "เกิดข้อผิดพลาด", "error");
              this.LOADER(false);
            });
        })

        .catch((err) => {
          this.$swal("กรุณาลองใหม่อีกครั้ง", "เกิดข้อผิดพลาด", "error");
          this.LOADER(false);
        });
    },
    async printPdf() {
      this.LOADER(true);
      let con_data = this.GET_CONTRACT;
      let product = this.GET_PRODUCT;
      let contract_data = {
        CONTRACT_ID: this.header,
        DATA: con_data,
        PACKAGE: product,
      };

      this.$token_api
        .post("/insert-duplicate-contract", contract_data)
        .then((response) => {
          this.$swal({
            title: "สำเร็จ",
            text: "สร้างสัญญา",
            timer: 2000,
            icon: "success",
          }).then((res) => {
            this.$download_api
              .get(`/donwload-contract-pdf/${this.header}`)
              .then((response) => {
                if (window.navigator.msSaveOrOpenBlob) {
                  window.navigator.msSaveOrOpenBlob(
                    response.data,
                    "สัญญา_" + this.header + ".pdf"
                  ); //IE is the worst!!!
                } else {
                  const url = window.URL.createObjectURL(
                    new Blob([response.data])
                  );
                  printJS(url);
                }
                this.dialog2 = false;
                this.LOADER(false);
              })
              .catch((err) => {
                this.$swal("กรุณาลองใหม่อีกครั้ง", "เกิดข้อผิดพลาด", "error");
                this.LOADER(false);
              });
            this.LOADER(false);
          });
        })
        .catch((err) => {
          this.$swal("กรุณาลองใหม่อีกครั้ง", "เกิดข้อผิดพลาด", "error");
          this.LOADER(false);
        });
    },
    async downloadPdf() {
      this.LOADER(true);
      let con_data = this.GET_CONTRACT;
      let product = this.GET_PRODUCT;
      let contract_data = {
        CONTRACT_ID: this.header,
        DATA: con_data,
        PACKAGE: product,
      };

      this.$token_api
        .post("/insert-duplicate-contract", contract_data)
        .then((response) => {
          this.$swal({
            title: "สำเร็จ",
            text: "สร้างสัญญา",
            timer: 2000,
            icon: "success",
          }).then((res) => {
            this.$download_api
              .get(`/donwload-contract/${this.header}`)
              .then((response) => {
                const url = window.URL.createObjectURL(
                  new Blob([response.data])
                );
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "สัญญา_" + this.header + ".docx");
                document.body.appendChild(link);
                link.click();
                this.LOADER(false);
              })
              .catch((err) => {
                this.$swal("กรุณาลองใหม่อีกครั้ง", "เกิดข้อผิดพลาด", "error");
                this.LOADER(false);
              });
            this.LOADER(false);
          });
        })
        .catch((err) => {
          this.$swal("กรุณาลองใหม่อีกครั้ง", "เกิดข้อผิดพลาด", "error");
          this.LOADER(false);
        });
    },
    back() {
      let _from = this.previousRoute;
      if (_from) {
        window.location.href = `${this.$global_link}${_from.path}`;
      } else {
        window.location.href = `${this.$global_link}`;
      }
    },
    price_option(item) {
      this.resetPrice();
      this.$store.dispatch("Contract/reset_product_list");
      this.vat_option = item;
    },

    list_c_period() {
      for (let index = 1; index < 6; index++) {
        this.contract_period.push(index.toString());
      }
    },
    clear_form() {
      this.$refs.form.reset();
      this.$store.dispatch("Contract/reset");
    },
    list_product() {
      this.$token_api
        .get("/list-product")
        .then((response) => {
          this.product = response.data.data;
          //console.log(response.data.data)
        })
        .catch((err) => {});
    },
    list_customer() {
      const _this = this;
      this.$token_api
        .get("/list-customer")
        .then((response) => {
          _this.hospname = response.data.data;
        })
        .catch((err) => {});
    },

    save() {
      // console.log(this.GET_CONTRACT)
      this.LOADER(true);
      let contract_data = {
        PACKAGE: this.GET_PRODUCT,
        DATA: this.GET_CONTRACT,
      };
      this.C_SET({ key: "DOC_STATUS", value: "อนุมันติ" });
      contract_data.CONTRACT_END_DATE = moment(
        contract_data.CONTRACT_END_DATE
      ).format("YYYY-MM-DD");

      // console.log(contract_data)
      if (this.$refs.form.validate()) {
        this.$token_api
          .post("/insert-duplicate-contract", contract_data)
          .then((response) => {
            this.$swal({
              title: "สำเร็จ",
              text: "สร้างสัญญาสำเร็จ",
              timer: 2000,
              icon: "success",
            }).then((res) => {
              this.$store.dispatch("Contract/reset");
              this.LOADER(false);
              // this.dialog = false
              this.back();
            });
          })
          .catch((err) => {
            this.$swal("กรุณาลองใหม่อีกครั้ง", "เกิดข้อผิดพลาด", "error");
            this.LOADER(false);
          });
      } else {
        this.$swal({
          title: "ข้อมูลไม่ครบ",
          text: "กรุณากรอกข้อมูลให้ครบถ้วน",
          timer: 2000,
          icon: "warning",
        });
        this.LOADER(false);
      }
    },
    edit() {
      console.log(this.GET_CONTRACT);
      this.LOADER(true);
      let contract_data = {
        PACKAGE: this.GET_PRODUCT,
        DATA: this.GET_CONTRACT,
      };
      // contract_data.CONTRACT_END_DATE = moment(
      //   contract_data.CONTRACT_END_DATE
      // ).format("YYYY-MM-DD");
      // console.log(contract_data.DATA.CONTRACT_END_DATE);
      if (this.$refs.form.validate()) {
        console.log(contract_data);
        this.$token_api
          .post("/insert-duplicate-contract", contract_data)
          .then((response) => {
            this.$swal({
              title: "สำเร็จ",
              text: "อัพเดทสัญญาสำเร็จ",
              timer: 2000,
              icon: "success",
            }).then((res) => {
              // this.$store.dispatch("Contract/reset");
              this.LOADER(false);
              // this.dialog = false
              // this.back();
            });
          })
          .catch((err) => {
            this.$swal("กรุณาลองใหม่อีกครั้ง", "เกิดข้อผิดพลาด", "error");
            this.LOADER(false);
          });
      } else {
        this.$swal({
          title: "ข้อมูลไม่ครบ",
          text: "กรุณากรอกข้อมูลให้ครบถ้วน",
          timer: 2000,
          icon: "warning",
        });
        this.LOADER(false);
      }
      contract_data.PACKAGE = this.GET_PRODUCT;
    },
    renewContract() {
      console.log(this.GET_CONTRACT);
      this.LOADER(true);
      let contract_data = {
        PACKAGE: this.GET_PRODUCT,
        DATA: this.GET_CONTRACT,
      };
      // contract_data.CONTRACT_END_DATE = moment(
      //   contract_data.CONTRACT_END_DATE
      // ).format("YYYY-MM-DD");
      // console.log(contract_data.DATA.CONTRACT_END_DATE);
      if (this.$refs.form.validate()) {
        console.log(contract_data);
        this.$token_api
          .post("/renew-insert-contract", contract_data)
          .then((response) => {
            this.$swal({
              title: "สำเร็จ",
              text: "อัพเดทสัญญาสำเร็จ",
              timer: 2000,
              icon: "success",
            }).then((res) => {
              // this.$store.dispatch("Contract/reset");
              this.LOADER(false);
              // this.dialog = false
              // this.back();
            });
          })
          .catch((err) => {
            this.$swal("กรุณาลองใหม่อีกครั้ง", "เกิดข้อผิดพลาด", "error");
            this.LOADER(false);
          });
      } else {
        this.$swal({
          title: "ข้อมูลไม่ครบ",
          text: "กรุณากรอกข้อมูลให้ครบถ้วน",
          timer: 2000,
          icon: "warning",
        });
        this.LOADER(false);
      }
      contract_data.PACKAGE = this.GET_PRODUCT;
    },
    close() {
      this.clear_form();
    },
    getPreviousRoute(from) {
      this.previousRoute = from;
    },
    resetPrice() {
      this.onlyVat3 = 0;
      this.onlyVat7 = 0;
      this.summary = 0;
      this.summaryVat3 = 0;
      this.totalVat7 = 0;
      this.exclude_7 = 0;
      this.C_SET({
        key: "ISVAT2",
        value: false,
      });
      this.C_SET({
        key: "ISVAT",
        value: false,
      });
    },
    getContractId(group) {
      this.$token_api
        .post("/get-contract-id", { CUSTOMER_GROUP: group })
        .then((response) => {
          this.header = response.data.data[0].con_id;
          this.C_SET({ key: "CONTRACT_ID", value: this.header });
        })
        .catch((err) => {});
    },
    change_contract(item) {},
    select_customer(item) {
      if (item) {
        this.$token_api
          .post("/get-customer-by-id", { CUSTOMER_ID: item.NEWCUSTOMER_ID })
          .then((response) => {
            let data = response.data.data[0];
            if (response.data.data.length > 0) {
              this.getContractId(data.CUSTOMER_GROUP);
              this.C_SET({
                key: "CUSTOMER_GROUP",
                value: data.CUSTOMER_GROUP,
              });
              this.C_SET({
                key: "CUSTOMER_TAX_ID",
                value: data.CUSTOMER_TAX_ID,
              });
              this.C_SET({
                key: "CUSTOMER_BRANCH",
                value: data.CUSTOMER_BRANCH,
              });
              this.SET_ELEM({
                key: "CUSTOMER_ADDRESS",
                value: data.CUSTOMER_ADDRESS,
              });
              this.C_SET({
                key: "CUSTOMER_PROVINCE",
                value: data.CUSTOMER_PROVINCE,
              });
              this.C_SET({
                key: "CUSTOMER_DISTRICT",
                value: data.CUSTOMER_DISTRICT,
              });
              this.C_SET({
                key: "CUSTOMER_SUBDISTRICT",
                value: data.CUSTOMER_SUBDISTRICT,
              });
              this.C_SET({
                key: "CUSTOMER_ZIPCODE",
                value: data.CUSTOMER_ZIPCODE,
              });
            }
          })
          .catch((err) => {});
      }
    },
    vat3_option(item) {
      let vat3 = this.GET_CONTRACT.ISVAT2;
      let vat7 = this.GET_CONTRACT.ISVAT;
      let p_option = this.vat_option;
      this.sumProductValue(vat7, vat3, p_option);
    },
    checked_vat7(item) {
      let vat3 = this.GET_CONTRACT.ISVAT2;
      let vat7 = this.GET_CONTRACT.ISVAT;
      let p_option = this.vat_option;
      this.sumProductValue(vat7, vat3, p_option);
    },
    checked_vat3(item) {
      this.isVat3 = item;
      let vat3 = this.GET_CONTRACT.ISVAT2;
      let vat7 = this.GET_CONTRACT.ISVAT;
      let p_option = this.vat_option;
      if (item) {
        this.C_SET({ key: "VAT_VALUE2", value: "3%" });
      } else {
        this.C_SET({ key: "VAT_VALUE2", value: "" });
      }
      this.sumProductValue(vat7, vat3, p_option);
    },
    price_option(item) {
      this.resetPrice();
      this.resetProduct();
      this.vat_option = item;
    },
    sumProductValue(vat7, vat3, p_option) {
      let product = this.GET_PRODUCT;
      let sum = product.reduce(
        (acc, item) => parseFloat(acc) + parseFloat(item.PRICE * item.AMOUT),
        0
      );
      if (p_option == "ราคาไม่รวมภาษี") {
        if (vat7 && !vat3) {
          this.onlyVat7 = (sum * 7) / 100;
          this.totalVat7 = sum + (sum * 7) / 100;
          this.onlyVat3 = 0;
          this.summaryVat3 = 0;
          this.C_SET({ key: "VAT_VALUE", value: "7%" });
          this.C_SET({ key: "VAT_VALUE2", value: "" });
        } else if (!vat7 && vat3) {
          this.onlyVat3 = (sum * parseFloat(this.vat3_value)) / 100;
          this.onlyVat7 = 0;
          this.totalVat7 = sum;
          this.C_SET({ key: "VAT_VALUE", value: "" });
          this.C_SET({ key: "VAT_VALUE2", value: this.vat3_value });
          this.summaryVat3 =
            parseFloat(this.totalVat7) - parseFloat(this.onlyVat3);
        } else if (vat7 && vat3) {
          this.onlyVat3 = (sum * parseFloat(this.vat3_value)) / 100;
          this.onlyVat7 = (sum * 7) / 100;
          this.totalVat7 = sum + (sum * 7) / 100;
          this.summaryVat3 =
            parseFloat(this.totalVat7) - parseFloat(this.onlyVat3);
          this.C_SET({ key: "VAT_VALUE", value: "7%" });
          this.C_SET({ key: "VAT_VALUE2", value: this.vat3_value });
        } else {
          this.onlyVat3 = 0;
          this.onlyVat7 = 0;
          this.totalVat7 = sum;
          this.C_SET({ key: "VAT_VALUE", value: "" });
          this.C_SET({ key: "VAT_VALUE2", value: "" });
        }
        this.summary = sum;
      } else {
        if (vat3) {
          this.onlyVat3 = (sum * parseFloat(this.vat3_value)) / 100;
          this.onlyVat7 = (sum * 7) / 100;
          this.totalVat7 = sum;
          this.exclude_7 = parseFloat(sum) - parseFloat(this.onlyVat7);
          this.summaryVat3 =
            parseFloat(this.onlyVat3) + parseFloat(this.exclude_7);
        } else {
          this.onlyVat7 = (sum * 7) / 100;
          this.totalVat7 = sum;
          this.exclude_7 = parseFloat(sum) - parseFloat(this.onlyVat7);
          this.onlyVat3 = 0;
          this.summaryVat3 = 0;
        }
        this.summary = sum;
      }

      return sum;
    },
    sumCol(index) {
      let product = this.GET_PRODUCT;
      return parseFloat(product[index].PRICE * product[index].AMOUT);
    },
    total_noVat() {
      return this.sumProductValue();
    },
    changeUnit() {
      let vat3 = this.GET_CONTRACT.ISVAT2;
      let vat7 = this.GET_CONTRACT.ISVAT;
      let p_option = this.vat_option;
      this.sumProductValue(vat7, vat3, p_option);
    },
    changePrice() {
      let vat3 = this.GET_CONTRACT.ISVAT2;
      let vat7 = this.GET_CONTRACT.ISVAT;
      let p_option = this.vat_option;
      this.sumProductValue(vat7, vat3, p_option);
    },
    add_product() {
      this.addProduct({
        INDEX: 0,
        NAME: "",
        DETAIL: "",
        AMOUT: 1,
        UNIT: "",
        PRICE: 0,
        TOTAL_PRICE: 0,
      });
    },
    delete_product(item) {
      this.$swal({
        title: "ต้องการลบสินค้าหรือไม่",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then(async (result) => {
        if (result.value) {
          await this.$token_api.delete("/delete-contract-product", {
            data: { CONTRACT_ID: this.header, PRODUCT_ID: item.PID },
          });
          this.delProduct(item);
        }
      });
    },
    select_combo(i, item) {
      this.product_list[i].PID = item.PID;
      this.product_list[i].NAME = item.NAME;
      this.product_list[i].UNIT = item.UNIT;
      this.product_list[i].DETAIL = item.DETAIL;
      this.product_list[i].PRICE = item.PRICE;
      let product = this.GET_PRODUCT;
      var valueArr = product.map(function (x) {
        return x.PID;
      });
      var isDuplicate = valueArr.some(function (item, idx) {
        return valueArr.indexOf(item) != idx;
      });
      if (isDuplicate) {
        this.$swal({
          title: "กรุณากรอกข้อมูลใหม่",
          text: "พบรายการสินค้าซ้ำ",
          timer: 2000,
          icon: "warning",
        }).then((res) => {
          this.delProduct(item);
        });
      }
    },
    change_con_type() {
      this.C_SET({ key: "CONTRACT_PERIOD", value: "" });
      this.C_SET({ key: "CONTRACT_END_DATE", value: "" });
    },
  },
};
</script>

